import { render } from "./particles.vue?vue&type=template&id=4a30ad2c"
import script from "./particles.vue?vue&type=script&lang=js"
export * from "./particles.vue?vue&type=script&lang=js"

import exportComponent from "D:\\DAIHAO\\AAAAA\\smart_brain_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__